import { CloseIcon } from '@braskai/icons';

import { ButtonBaseProps } from '@mui/material';

import { SCloseButton } from './styled';

export const CloseButton = (props: ButtonBaseProps) => {
  return (
    <SCloseButton {...props}>
      <CloseIcon height={16} width={16} />
    </SCloseButton>
  );
};
